import { render, staticRenderFns } from "./PageLearningUnitInfo.vue?vue&type=template&id=4a99ac08&"
import script from "./PageLearningUnitInfo.vue?vue&type=script&lang=js&"
export * from "./PageLearningUnitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports